import { userLoggedOut } from "../auth/authSlice";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// const baseQuery = fetchBaseQuery({
//   baseUrl: "http://localhost:3000/",
//   prepareHeaders: async (headers, { getState, endpoint }) => {
//     const token = getState()?.auth?.accessToken;
//     if (token) {
//       headers.set("Authorization", `Bearer ${token}`);
//     }

//     return headers;
//   }
// });


const baseQuery = fetchBaseQuery({
  baseUrl: "https://.myospaz.in/",
  prepareHeaders: async (headers, { getState, endpoint }) => {
    const token = getState()?.auth?.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  }
});


export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result?.error?.status === 401) {
      api.dispatch(userLoggedOut());
      localStorage.removeItem("accessToken");
    }
    return result;
  },
  // baseQuery: fetchBaseQuery({ baseUrl: "http://localhost:3000", axios }),
  tagTypes: [],
  endpoints: (builder) => ({})
});
